// 导入组件，组件必须声明 name
import VueEchartsEditor from './src/main.vue'
import state from './src/store/index'
import { veeStoreName } from './src/store/name'

// 为组件添加 install 方法，用于按需引入
VueEchartsEditor.install = function(Vue, { store } = {}) {
  if (VueEchartsEditor.install.installed) return false
  VueEchartsEditor.install.installed = true
  if (store) {
    store.registerModule(veeStoreName, state)
  }
  Vue.component(VueEchartsEditor.name, VueEchartsEditor)
}
export default VueEchartsEditor
